import { useSyncExternalStore } from 'react';
import { brandingActual, suscribirBranding } from './aplicar';
import type { Branding } from './catalogo';

/** El branding activo, reactivo: cambia cuando la sesión resuelve la empresa. */
export function useBranding(): Branding {
  return useSyncExternalStore(suscribirBranding, brandingActual, brandingActual);
}
